import headerNavigation from "./navigation/header";
import headerProductReview from "./navigation/header-product-review";

import footerNavigation from "./navigation/footer";
import socialMedia from "./navigation/social-media";

// --> shared
import componentA8fee867 from "./shared/component-a8fee867";
import componentFd7c0f94 from "./shared/component-fd7c0f94";
import componentE505c56b from "./shared/component-e505c56b";
import componentAe9a2301 from "./shared/component-ae9a2301";
import componentB171a7fa from "./shared/component-b171a7fa";
import componentB4c019ae from "./shared/component-b4c019ae";
import componentD741a204 from "./shared/component-d741a204";
import componentCfc6264d from "./shared/component-cfc6264d";
import componentFebbc050 from "./shared/component-febbc050";
import componentB9a1af4d from "./shared/component-b9a1af4d";
import componentA7efd289 from "./shared/component-a7efd289";
import componentB7965f79 from "./shared/component-b7965f79";
import componentF80cbcd0 from "./shared/component-f80cbcd0";
import componentD6b883a3 from "./shared/component-d6b883a3";
import componentE32ed487 from "./shared/component-e32ed487";
import componentFf7346f1 from "./shared/component-ff7346f1";
import componentDe0817df from "./shared/component-de0817df";
import componentBbf0c1bb from "./shared/component-bbf0c1bb";
import componentEa0617ff from "./shared/component-ea0617ff";
import componentB3e55151 from "./shared/component-b3e55151";
import componentD4bef2ce from "./shared/component-d4bef2ce";
import componentBd673c97 from "./shared/component-bd673c97";
import componentDaef29d2 from "./shared/component-daef29d2";
import componentD3661978 from "./shared/component-d3661978";
import componentA07213a1 from "./shared/component-a07213a1";
import componentD7bb860f from "./shared/component-d7bb860f";
import componentAc95c94b from "./shared/component-ac95c94b";
import componentCcc69593 from "./shared/component-ccc69593";
import componentD6f08142 from "./shared/component-d6f08142";
import componentA590b44b from "./shared/component-a590b44b";
import componentEbbdd2bb from "./shared/component-ebbdd2bb";
import componentDf54bc0c from "./shared/component-df54bc0c";
import componentA5e7ae66 from "./shared/component-a5e7ae66";
import componentC6d2ee83 from "./shared/component-c6d2ee83";
import componentFcbecf18 from "./shared/component-fcbecf18";
import componentCdfa9ab3 from "./shared/component-cdfa9ab3";
import componentCf612bc7 from "./shared/component-cf612bc7";
import componentA03fdab7 from "./shared/component-a03fdab7";
import componentB94713bb from "./shared/component-b94713bb";
import componentF67cbdf8 from "./shared/component-f67cbdf8";
import componentC57cd1bd from "./shared/component-c57cd1bd";
import componentF39478b9 from "./shared/component-f39478b9";
import componentF0a51cd8 from "./shared/component-f0a51cd8";
import componentEd6a5b36 from "./shared/component-ed6a5b36";
import componentC225c07b from "./shared/component-c225c07b";
import componentDe94ab88 from "./shared/component-de94ab88";
import componentAaeec3b4 from "./shared/component-aaeec3b4";
import componentD339d3de from "./shared/component-d339d3de";
import componentA17eeba3 from "./shared/component-a17eeba3";
import componentBe3cb184 from "./shared/component-be3cb184";
import componentDdf36607 from "./shared/component-ddf36607";
import componentA0c1dfbe from "./shared/component-a0c1dfbe";
import componentCfc2194d from "./shared/component-cfc2194d";
import componentCe7dba28 from "./shared/component-ce7dba28";
import componentE360d18d from "./shared/component-e360d18d";
import componentEc8273f4 from "./shared/component-ec8273f4";
import componentHzl8uip8 from "./shared/component-hzl8uip8"; // product_manual_list
import componentSue7nhwz from "./shared/component-sue7nhwz"; // product_manual_list_recently_viewed
import componentDacacb90 from "./shared/component-dacacb90";
import componentM42pon65 from "./shared/component-m42pon65";
import componentZ49ajfa5 from "./shared/component-z49ajfa5";
import componentI93jfna3 from "./shared/component-i93jfna3";
import componentBc463569 from "./shared/component-bc463569";
import componentCcea5026 from "./shared/component-ccea5026";
import componentC577191a from "./shared/component-c577191a";
import componentAb0f2fd5 from "./shared/component-ab0f2fd5";
import componentBb9016f3 from "./shared/component-bb9016f3";
import componentD494790c from "./shared/component-d494790c"; // feature_fullwidth_icon-line_h54_text_cta
import componentF7d0bf1d from "./shared/component-f7d0bf1d"; // info_icon-line_text_list_cta
import componentEb152cd5 from "./shared/component-eb152cd5"; // info_25/75_icon-line_list_image-readmore-less
import componentAeb26ed5 from "./shared/component-aeb26ed5"; // product_ratings_and_reviews
import componentCard from "./shared/component-card";
import productList from "./shared/product-list"; // product_li
import productSupport from "./shared/product-support"; //Support Banner
import documentLink from "./shared/document-link"; //Document Link
import globalHome from "./shared/global-home"; //Global home page
import glossary from "./shared/glossary"; //Glossary component
import newsfeedComponent from "./shared/newsfeed-component"; //newsfeed component
import announcements from "./shared/announcements"; //announcements_component
import extlinkcards from "./shared/extlinkcards"; //extlinkcards
import extlinkcardswd from "./shared/extlinkcardswd"; //extlinkcards-wd
import profhpwrapper from "./shared/profhpwrapper"; // professional wrapper

// -> forms
import componentD0b82bdc from "./shared/component-d0b82bdc"; // contact form
import component0b2c6190 from "./shared/component-0b2c6190"; // Product review

import component0b2c6199 from "./shared/component-0b2c6199"; // Product review

// --> shared support
import animation from "./shared-support/animation";
import eyebrowIcon from "./shared-support/eyebrow-icon";
import modalVideo from "./shared-support/modal-video";
import searchForm from "./shared-support/search-form";
import blogBreadcrumb from "./shared-support/blog-breadcrumb";
import ratings from "./shared-support/ratings";
import modalAnnouncement from "./shared-support/modal-announcement";
import productsBreadcrumb from "./shared-support/products-breadcrumb";
import tabComponent from "./shared/tab-component";
import pageloader from "./shared-support/pageloader"

// --> sleepapnea
import componentCb51a9b2 from "./sleepapnea/component-cb51a9b2"; // cpap equipment: the complete system
import componentAb289181 from "./sleepapnea/component-ab289181"; // sleep_apnea_product_list
import componentC70022cc from "./sleepapnea/component-c70022cc"; // sleep_apnea_product_list_recently_viewed
import componentBed1ea29 from "./sleepapnea/component-bed1ea29";
import componentA4c86042 from "./sleepapnea/component-a4c86042";
import componentF84d9a52 from "./sleepapnea/component-f84d9a52";
import componentC669ebd7 from "./sleepapnea/component-c669ebd7";
import componentB910a4bd from "./sleepapnea/component-b910a4bd"; // sleep blog - tags
import componentD2255999 from "./sleepapnea/component-d2255999"; // sleep blog - popular related articles
import componentA12b3dfe from "./sleepapnea/component-a12b3dfe"; // store locator
import componentEa825d9c from "./sleepapnea/component-ea825d9c"; // featured-online-retailers
import componentFf839c09 from "./sleepapnea/component-ff839c09"; // all-online-retailers
import componentDea9b99e from "./sleepapnea/component-dea9b99e"; // feature_mask_selector_text_cta_info
import maskSelectorQuiz from "./sleepapnea/component-mask-selector-quiz"; // mask selector quiz
import componentB76df896 from "./sleepapnea/component-b76df896"; // recommended_50/50_mask_name_type_video_2cta

// --> index
import welcomeLearnAbout from "./consumers/learn-about";
import areaOfInterest from "./consumers/area-of-interest";
import sleepApneaSolutions from "./consumers/sleep-apnea-solutions";
import portableOxygenSolutions from "./consumers/portable-oxygen-solutions";
import ventilationSolutions from "./consumers/ventilation-solutions";
import forProfessionals from "./consumers/for-professionals";
import saasSolutions from "./consumers/saas-solutions";
import componentB80a8704 from "./consumers/component-b80a8704"; // executive team
import componentAa599ce7 from "./consumers/component-aa599ce7"; // warranty information

export default {
  // navigation
  headerNavigation,
  footerNavigation,
  socialMedia,
  headerProductReview,

  // index
  welcomeLearnAbout,
  areaOfInterest,
  sleepApneaSolutions,
  portableOxygenSolutions,
  ventilationSolutions,
  forProfessionals,
  saasSolutions,
  componentB80a8704,
  componentAa599ce7,
  productSupport,
  documentLink,
  globalHome,
  glossary,
  newsfeedComponent,
  announcements,
  extlinkcards,
  extlinkcardswd,
  profhpwrapper,

  // shared
  componentA8fee867,
  componentFd7c0f94,
  componentE505c56b,
  componentAe9a2301,
  componentB171a7fa,
  componentB4c019ae,
  componentFebbc050,
  componentD741a204,
  componentB9a1af4d,
  componentCfc6264d,
  componentA7efd289,
  componentB7965f79,
  componentF80cbcd0,
  componentD6b883a3,
  componentE32ed487,
  componentFf7346f1,
  componentDe0817df,
  componentBbf0c1bb,
  componentEa0617ff,
  componentB3e55151,
  componentD4bef2ce,
  componentBd673c97,
  componentDaef29d2,
  componentD3661978,
  componentA07213a1,
  componentD7bb860f,
  componentAc95c94b,
  componentCcc69593,
  componentD6f08142,
  componentA590b44b,
  componentEbbdd2bb,
  componentDf54bc0c,
  componentA5e7ae66,
  componentC6d2ee83,
  componentFcbecf18,
  componentCdfa9ab3,
  componentCf612bc7,
  componentA03fdab7,
  componentB94713bb,
  componentF67cbdf8,
  componentC57cd1bd,
  componentF39478b9,
  componentF0a51cd8,
  componentEd6a5b36,
  componentC225c07b,
  componentDe94ab88,
  componentAaeec3b4,
  componentD339d3de,
  componentA17eeba3,
  componentBe3cb184,
  componentDdf36607,
  componentA0c1dfbe,
  componentCfc2194d,
  componentCe7dba28,
  componentE360d18d,
  componentSue7nhwz,
  componentHzl8uip8,
  componentEc8273f4,
  componentDacacb90,
  componentM42pon65,
  componentZ49ajfa5,
  componentI93jfna3,
  componentBc463569,
  componentCcea5026,
  componentC577191a,
  componentAb0f2fd5,
  componentBb9016f3,
  componentD494790c,
  componentF7d0bf1d,
  componentEb152cd5,
  componentAeb26ed5,
  componentCard,
  productList,
  tabComponent,
  pageloader,

  // forms
  componentD0b82bdc,
  component0b2c6190,
  component0b2c6199,

  // sleepapnea
  componentCb51a9b2,
  componentAb289181,
  componentC70022cc,
  componentBed1ea29,
  componentA4c86042,
  componentF84d9a52,
  componentC669ebd7,
  componentB910a4bd,
  componentD2255999,
  componentA12b3dfe,
  componentEa825d9c,
  componentFf839c09,
  componentDea9b99e,
  maskSelectorQuiz,
  componentB76df896,

  // shared support
  animation,
  eyebrowIcon,
  modalVideo,
  searchForm,
  blogBreadcrumb,
  ratings,
  modalAnnouncement,
  productsBreadcrumb,
};
